import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  count: 0,
  next: null,
  previous: null,
  results: [],
};

const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    setOrders(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
});

export const { setOrders } = ordersSlice.actions;

export default ordersSlice.reducer;
